import { TagToComponentMap } from "nwon-html-to-react";

export const mappedUnorderedLists: TagToComponentMap = {
  ul: ({ children, attributes }) => {
    return <ul {...attributes}>{children}</ul>;
  },
};
